import { Util } from "/global/js/util.min.js?v=1749578964";
import { t } from "/global/js/translations.min.js?v=1749035975";
const util = new Util();
export default class Events {
  constructor(id) {
    this.id = id;
    this.module = document.querySelector("#" + this.id);
    this.module.style.minHeight = '100px';
    this.parent = this.module.parentNode;
    this.settings = JSON.parse(decodeURIComponent(this.parent.dataset.settings));
    const head = document.querySelector('head');
    const style = document.createElement('style');
    style.innerHTML = `
            .events .row{
                border-top: 1px solid #ECECEC;
            }
            
            @media only screen and (min-width: 768px) {
                .events .date{
                    border-right: 1px solid #ECECEC;
                    border-left: 1px solid #ECECEC;
                }
            }
        `;
    head.appendChild(style);
    (async () => {
      this.t = await t;
      this.monthNames = [this.t.__("January"), this.t.__("February"), this.t.__("March"), this.t.__("April"), this.t.__("May"), this.t.__("June"), this.t.__("July"), this.t.__("August"), this.t.__("September"), this.t.__("October"), this.t.__("November"), this.t.__("December")];
      const formData = new FormData();
      formData.append('contentEntity', this.settings.categoryId);
      formData.append('selectDaysBack', '0');
      if (util.isAdmin()) {
        formData.append('defaultLanguageBackendId', '1');
      }
      fetch('/global/ajaxHandlerGlobal.php?handler=getContentsChildrenJoinParents', {
        method: "POST",
        body: formData
      }).then(response => {
        response.json().then(response => {
          if (response.error) {
            pubsub.trigger('error', response);
            return;
          }
          this.content = response.content;
          this.render();
        });
      });
    })();
  }
  render() {
    if (!this.content || this.content.length === 0) {
      this.module.innerHTML = `
                <div class="col-12">
                    ${this.t.__("Currently no event planned")}
                </div>
            `;
      return;
    }

    /* Saml events i et object med mmånedÅr som key og events som value */
    const monthYears = {};
    for (const content of this.content) {
      const eventStartDate = new Date(content.childStartDate + ' ' + content.childStartTime);
      const monthName = this.monthNames[eventStartDate.getMonth()];
      const year = eventStartDate.getFullYear();
      const monthYear = monthName + ' ' + year;
      if (!monthYears[monthYear]) {
        monthYears[monthYear] = [content];
      } else {
        monthYears[monthYear].push(content);
      }
    }
    let firstRun = true;
    const contentElem = document.createElement('div');
    contentElem.classList.add('events', 'px-0');
    let content = ``;
    for (const [monthYear, events] of Object.entries(monthYears)) {
      if (firstRun) {
        const firstEvent = events[0];
        const firstEventParentContJson = firstEvent.parentContJson = JSON.parse(firstEvent.parentContJson);
        const firstEventChildContJson = firstEvent.childContJson = JSON.parse(firstEvent.childContJson);
        if (firstEventParentContJson?.contentTypesArtistImage && firstEventParentContJson.contentTypesArtistImage.length > 0) {
          content = `
                        <div class="position-relative">
                            <div class="position-absolute bottom-0 start-0 p-3">
                                <p class="headline4" style="text-shadow:0 3px 6px #000; margin-bottom: -8px;">${this.t.__("Concert")} - ${firstEventChildContJson.startDate}</p>
                                <h1 class="mb-0" style="text-shadow:0 3px 6px #000;">${firstEvent.contlName}</h1>
                            </div>
                            <img class="img-fluid" style="object-fit: contain;" src="/userFiles/contentTypes/contentTypeEvents/large/${firstEventParentContJson.contentTypesArtistImage[0].imageName}">
                        </div>
                    `;
        }
      }
      if (firstRun) {
        content += `<div class="px-3">`;
      }
      content += `
                <div class="mt-5">
                    ${firstRun ? `<p class="headline5 text-secondary mb-0">${this.t?.department?.depaName ?? ''}</p>` : ''}
                    <h2>${monthYear}</h2>
                </div>
            `;
      for (const event of events) {
        event.childContJson = typeof event.childContJson === 'string' ? JSON.parse(event.childContJson) : event.childContJson;
        event.parentContJson = typeof event.parentContJson === 'string' ? JSON.parse(event.parentContJson) : event.parentContJson;
        content += `
                    <div class="row gx-0 py-3 mb-3 mb-md-0">
                        <div class="col-md order-1 order-md-0">
                            <div class="my-md-2">
                                <p class="headline3 mb-0" role="heading">${event.contlName}</p>
                            </div>
                        </div>
                        
                        <div class="col-md order-0 order-md-1">
                            <div class="my-md-2 date text-md-center">
                                ${event.childContJson.startDate ? `
                                    <p class="headline5 mb-0 d-md-none">${event.childContJson.startDate} <span class="mb-0">${this.t.__("at.") + " " + event.childContJson.startTime}</span></p> <!--Mobile -->
                                    <p class="headline3 mb-0 d-none d-md-block">${event.childContJson.startDate} <span class="headline6 mb-0 d-block">${this.t.__("at.") + " " + event.childContJson.startTime}</span></p> <!--Desktop -->
                                ` : ''}
                            </div>
                        </div>
                        
                        <div class="col-md order-2">
                            <div class="my-md-2 text-md-end">
                                ${event.childContJson.contentTypesLink ? `
                                    <a href="${event.childContJson.contentTypesLink}" class="headline5 d-md-none" rel="noopener">${this.t.__("Read more")}</a> <!--Mobile -->
                                    <a href="${event.childContJson.contentTypesLink}" class="btn btn-primary d-none d-md-inline-block" rel="noopener">${this.t.__("Read more")}</a> <!--Desktop -->
                                ` : ''}
                                ${!event.childContJson.contentTypesLink && event.contlTextLong ? `
                                    <a href="/${this.t.langCode + this.t.pwaUrl}/content/events/${event.contUrlName}" class="headline5 d-md-none" rel="noopener">${this.t.__("Read more")}</a> <!--Mobile -->
                                    <a href="/${this.t.langCode + this.t.pwaUrl}/content/events/${event.contUrlName}" class="btn btn-primary d-none d-md-inline-block" rel="noopener">${this.t.__("Read more")}</a> <!--Desktop -->
                                ` : ''}
                            </div>
                        </div>
                    </div>
                `;
      }
      firstRun = false;
    }
    if (firstRun) {
      content += `</div>`;
    }
    contentElem.innerHTML = content;
    this.module.appendChild(contentElem);
  }
}